import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import Addresume from "../../pages/jobapplypages/Addresume";
import EmployersQuestionPage from "../../pages/jobapplypages/EmployersQuestionPage";
import JobReleventExperianceDetailsForm from "../../pages/jobapplypages/JobReleventExperianceDetailsForm";
import ApplyJobReviewPage from "../../pages/jobapplypages/ApplyJobReviewPage";
import ResponsePage from "../../pages/jobapplypages/ResponsePage";
import { applyJobsByJobSeeker, applyJobsdataFromBody, getJobSeeker } from "../../helpers/backendHelper";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import ViewJobs from "../ViewJobs";
import { decryptParam } from "../../helpers/UrlEncryptDecrypt";

function JobapplyHomePage() {

  const secretKey = process.env.REACT_APP_WALKUPP_SECRET_KEY || "walkupp-secret-key";

    let { jobId } = useParams();

    jobId = decryptParam(jobId,secretKey);
    console.log("jobId",jobId);
    
    const navigate = useNavigate();
  
    const { user } = useSelector(state => ({
      user: state.Login.user,
    }));
      
    const [step, setStep] = useState(1);
    const [jobApplyData,setJobApplyData] = useState({});
    const [jobSeekerDetail,setJobSeekerDetail] = useState({});
    const [statusCheck,setStatusCheck ] = useState("");

    const fetchJobSeeker = async() => {
      const response = await getJobSeeker();
      console.log("response of getJobSeeker", response.jobseeker);
      setJobSeekerDetail(response.jobseeker);
    }
     
    useEffect(()=>{
      fetchJobSeeker();
    },[]);
    
    const handleContinue = async (data) => {
      console.log("data of submit");
      
    // setJobApplyData({...jobApplyData,...data});
    const updatedApplyData = {...jobApplyData, ...data };
    setJobApplyData(updatedApplyData);

    console.log("data...",data);
    console.log("updatedApplyData...",updatedApplyData);
    console.log("jobApplyData....",jobApplyData);
    
      if(step === 3){
        console.log("step 3 jobApplyData",jobApplyData);
        console.log("step 3 updatedApplyData",updatedApplyData);
        console.log("step 3 data",data);
        
        if(jobApplyData.file){
          const formData = new FormData();
          formData.append('resume', jobApplyData.file); 
          formData.append('jobId',jobId);

          try{
            const response = await applyJobsByJobSeeker(formData);
            console.log("response....",response);
            if(response && response.statusCode === 400){
              setStatusCheck(response.message)
            }
            setStep(step + 1);
            console.log("formData",formData);
          }
          catch(e){
            console.log(e,'e')
          }
        }
        else{
          // formData.append('isExistingResume', true); 
          // formData.append('existingResumePath', data.resumePath); 
          // formData.append('jobId',jobId);

          const payload = {
            isExistingResume: true,
            existingResumePath: data.resumePath,
            jobId: jobId
          }
          try {
            const response = await applyJobsdataFromBody(payload);
            console.log("payload of applyJobsdataFromBody",payload);
            console.log("response....",response);
            if(response && response.statusCode === 400){
              setStatusCheck(response.message)
            }
            setStep(step + 1);
          } catch (error) {
            console.log(error,'error')
          }
        }
        
      }
      else{
        setStep(step + 1);
      }
  };

  const backFunction =()=> {
    if(step === 1){
      navigate(-1);
    }
    else{
      setStep(step - 1);
    }
  }

  useEffect(() => {
  }, [jobApplyData]);
  
  return (
    <div  style={{backgroundColor:"#F3F9FE"}}>
      <Navbar />
      <div>
        {step === 1 && <Addresume onContinue={handleContinue} jobSeeker={jobSeekerDetail} back={backFunction} />}
        {/* {step === 2 && <EmployersQuestionPage onContinue={handleContinue} />} */}
        {step === 2 && (
          <JobReleventExperianceDetailsForm onContinue={handleContinue} back={backFunction} />
        )}
        {step === 3 && <ApplyJobReviewPage onContinue={handleContinue} jobApplyData={jobApplyData} jobSeeker={jobSeekerDetail} back={backFunction} />}
        {step === 4 && <ResponsePage jobApplyData={jobApplyData} applyCheck={statusCheck} />}
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
}

export default JobapplyHomePage;
